import { render } from "./CodigoInvalido.vue?vue&type=template&id=797cb4a2"
import script from "./CodigoInvalido.vue?vue&type=script&lang=js"
export * from "./CodigoInvalido.vue?vue&type=script&lang=js"

import "./CodigoInvalido.vue?vue&type=style&index=0&id=797cb4a2&lang=scss"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__